import axiosInstance from "../../../Utils/axiosInstance";


export const getOpenTradeHistory = async () => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/open-trade-history/`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};

export const getAllTradeHistory = async () => {
  try {
    const response = await axiosInstance.get(
      `/paper-app/all-trade-history/`
    );
    const data = response.data;
    return { data: data, error: null };
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Unknown error";
    return { data: null, error: message };
  }
};